import React from 'react';
import { AlertTriangle, PlugZap } from 'lucide-react';

interface Props {
  message: string;
  onRetry: () => void;
  onBack: () => void;
}

const InterviewErrorState: React.FC<Props> = ({ message, onRetry, onBack }) => (
  <div className="max-w-md mx-auto">
    <div className="border border-red-200 rounded-card shadow-soft bg-white p-6 text-center">
      <div className="w-12 h-12 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-3">
        <AlertTriangle className="w-5 h-5 text-red-500" />
      </div>
      <h3 className="font-display font-semibold text-foreground mb-1.5">Interview unavailable</h3>
      <p className="text-sm text-zinc-500 mb-5">{message}</p>
      <div className="flex gap-2 justify-center">
        <button
          onClick={onRetry}
          className="h-10 px-4 inline-flex items-center gap-1.5 text-sm font-semibold text-white bg-brand-500 hover:bg-brand-600 rounded-btn transition-colors"
        >
          <PlugZap className="w-4 h-4" /> Retry
        </button>
        <button
          onClick={onBack}
          className="h-10 px-4 text-sm font-medium text-zinc-600 hover:bg-zinc-50 rounded-btn transition-colors"
        >
          Back to application
        </button>
      </div>
    </div>
  </div>
);

export default InterviewErrorState;